var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup21458(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21458",
    "data-name": "Group 21458",
    transform: "translate(-40 -426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21445",
    "data-name": "Group 21445",
    transform: "translate(24 262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 45,
    height: 45,
    rx: 5,
    transform: "translate(16 164)",
    fill: "#ff7b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21413",
    "data-name": "Group 21413",
    transform: "translate(10 -32.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27145",
    "data-name": "Path 27145",
    d: "M4.308,0a1.026,1.026,0,0,1,.856.578A.872.872,0,0,1,5,1.585c-.409.467-.854.909-1.22,1.409A10.174,10.174,0,0,0,4.788,16.173a1.053,1.053,0,0,1,.432.968.885.885,0,0,1-.617.724.859.859,0,0,1-.919-.232A11.5,11.5,0,0,1,.526,12.465,11.816,11.816,0,0,1,2.84,1.252,8.066,8.066,0,0,1,3.7.343,3.065,3.065,0,0,1,4.308,0",
    transform: "translate(40 472.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27146",
    "data-name": "Path 27146",
    d: "M270.584,10.2a12.094,12.094,0,0,1-3.668,8.765.891.891,0,1,1-1.25-1.262,9.954,9.954,0,0,0,2.96-5.617,10.031,10.031,0,0,0-2.7-8.8c-.113-.123-.241-.233-.344-.364a.885.885,0,0,1,1.3-1.19A11.8,11.8,0,0,1,270.46,8.8c.069.514.093,1.035.125,1.4",
    transform: "translate(-205.584 470.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27147",
    "data-name": "Path 27147",
    d: "M212.869,43.086a8.307,8.307,0,0,1-2.494,5.923.9.9,0,0,1-1.335.068.912.912,0,0,1,.078-1.336,6.472,6.472,0,0,0,0-9.292.909.909,0,0,1-.074-1.335.9.9,0,0,1,1.334.071,8.309,8.309,0,0,1,2.493,5.9",
    transform: "translate(-153.236 438.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27148",
    "data-name": "Path 27148",
    d: "M71.945,43.513A8.182,8.182,0,0,1,74.4,37.8a.9.9,0,0,1,1.332-.054.913.913,0,0,1-.079,1.316,6.521,6.521,0,0,0-.045,9.178c.052.054.106.1.155.16a.885.885,0,0,1,0,1.253.872.872,0,0,1-1.251,0A8.025,8.025,0,0,1,73,47.706a8.5,8.5,0,0,1-1.053-4.193",
    transform: "translate(-26.587 437.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27149",
    "data-name": "Path 27149",
    d: "M147.437,98.543a1.783,1.783,0,1,1-1.8-1.778,1.788,1.788,0,0,1,1.8,1.778",
    transform: "translate(-93.156 382.757)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21458);
export default __webpack_public_path__ + "static/media/Group 21458.ac1ae484d1beadb7caa7f6ff838ad742.svg";
export { ForwardRef as ReactComponent };